import type { FileMapDataSubcategory } from '../types'
import { litAbsentDataLegend, litLineLayers, litLineLegends } from './layers/lit'
import { wrapSourceLayers } from './layers/utils/wrapSourceLayers'

const subcatId = 'lit_bikelanes'
const source = 'atlas_bikelanes'
const sourceLayer = 'bikelanes'
export type SubcatLitBikelanesId = typeof subcatId
export type SubcatLitBikelanesStyleIds = 'default'

export const subcat_lit_bikelanes: FileMapDataSubcategory = {
  id: subcatId,
  name: 'Radverkehrsanlagen',
  ui: 'checkbox',
  sourceId: source,
  beforeId: 'atlas-app-beforeid-top',
  styles: [
    {
      id: 'default',
      name: 'Beleuchtung',
      layers: wrapSourceLayers({
        layers: litLineLayers(),
        source,
        sourceLayer,
        idPrefix: sourceLayer,
      }),
      legends: [...litLineLegends, litAbsentDataLegend],
    },
  ],
}
